import React from "react";
import { Container } from 'react-bootstrap';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner industry-back">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">INDUSTRIES</h2>
						<div className="red-border"> </div>
						<p>digiPanda helps accelerate innovation and gratify industry specific best practices to help run your core business efficiently.</p>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
